import {Types} from 'mongoose';

export const INCOME = {
    type: 'Income',
    category: 'System',
    value: [
        {label: 'No Income', _id: new Types.ObjectId('507f1f77bcf86cd799439022')},
        {
            label: '$1 - $9,999',
            _id: new Types.ObjectId('507f1f77bcf86cd799439023'),
        },
        {
            label: '$10,000 - $19,999',
            _id: new Types.ObjectId('507f1f77bcf86cd799439024'),
        },
        {
            label: '$20,000 - $29,999',
            _id: new Types.ObjectId('507f1f77bcf86cd799439025'),
        },
        {
            label: '$30,000 - $39,999',
            _id: new Types.ObjectId('507f1f77bcf86cd799439026'),
        },
        {
            label: '$40,000 - $49,999',
            _id: new Types.ObjectId('507f1f77bcf86cd799439027'),
        },
        {
            label: '$50,000 - $59,999',
            _id: new Types.ObjectId('507f1f77bcf86cd799439028'),
        },
        {
            label: '$60,000 - $64,999',
            _id: new Types.ObjectId('507f1f77bcf86cd799439029'),
        },
        {
            label: 'Above $65,000',
            _id: new Types.ObjectId('507f1f77bcf86cd799439030'),
        },
        {
            label: 'Prefer Not to Answer',
            _id: new Types.ObjectId('507f1f77bcf86cd799439031'),
        },
    ].map(d => d),
};
